export const STATUS_POLICY_CHECK_DATA  = [
    { text: 'INTAKE.ADD-TRAVEL-INSURANCE.HELP_BEFORE_CHECK', id:1},
    { text:'INTAKE.ADD-TRAVEL-INSURANCE.STILL_TO_BE_CHECKED' , id:2},
    { text:'INTAKE.ADD-TRAVEL-INSURANCE.NO_COVERAGE', id:3},
    { text:'INTAKE.ADD-TRAVEL-INSURANCE.OK', id:4},
    { text:'INTAKE.ADD-TRAVEL-INSURANCE.NOT_OK', id:5},
    { text:'INTAKE.ADD-TRAVEL-INSURANCE.NOT_APPLICABLE', id:6},
    { text:'INTAKE.ADD-TRAVEL-INSURANCE.REJECTED', id:7}
]


export enum TRAVEL_SATATUS_CHECK {
    NOT_APPLICABLE = 6,
    OK = 4,
    HELP_BEFORE_CHECK = 1
}